import React from 'react';
import { IconStars01, IconSupergatorByHostgator } from 'gatorcomponents';
import { supergatorAnalytics } from '@/analytics/supergator';
import * as Styles from './Hero.styles';
import heroChatImg from '../../media/hero-chat.png';
import CtaButton from '../CtaButton';
import useSupergatorSso from '@/hooks/useSupergatorSso';

const Hero = ({ locale }) => {
  const { redirectToSupergator, loading } = useSupergatorSso();

  const handleCtaClick = () => {
    supergatorAnalytics.heroCtaClick({ label: locale.cta });
    redirectToSupergator();
  };

  return (
    <Styles.Wrapper>
      <Styles.LogoWrapper>
        <Styles.LogoRow>
          <IconSupergatorByHostgator width={141} height={32} />
          <Styles.BetaBadge>
            <Styles.BetaBadgeText>{locale.betaTag}</Styles.BetaBadgeText>
          </Styles.BetaBadge>
        </Styles.LogoRow>
      </Styles.LogoWrapper>
      <Styles.Content>
        <Styles.LeftSide>
          <Styles.TitleWrapper>
            {`${locale.titleNormal} `}
            <Styles.TitleGradient>
              <span dangerouslySetInnerHTML={{ __html: locale.titleGradient }} />
              <Styles.StarsIcon>
                <IconStars01 gradient="tertiary" />
              </Styles.StarsIcon>
            </Styles.TitleGradient>
          </Styles.TitleWrapper>
          <Styles.Subtitle>{locale.subtitle}</Styles.Subtitle>
          <CtaButton onClick={handleCtaClick} disabled={loading}>
            {locale.cta}
          </CtaButton>
        </Styles.LeftSide>
        <Styles.RightSide>
          <Styles.HeroImage
            src={heroChatImg}
            alt={locale.imageAlt}
            width={710}
            height={788}
          />
        </Styles.RightSide>
      </Styles.Content>
    </Styles.Wrapper>
  );
};

export default Hero;
